import { render, staticRenderFns } from "./AdminTopRecettes.vue?vue&type=template&id=1fc1b1c3&scoped=true"
import script from "./AdminTopRecettes.vue?vue&type=script&lang=js"
export * from "./AdminTopRecettes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc1b1c3",
  null
  
)

export default component.exports